import { render, staticRenderFns } from "./EnrolmentAdmitted.vue?vue&type=template&id=15e8b42d"
import script from "./EnrolmentAdmitted.vue?vue&type=script&lang=js"
export * from "./EnrolmentAdmitted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports